import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs'; import { SanctumService } from 'src/app/services/sanctum.service';
import { IStoreData } from '../@types/Store'; import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { retry, catchError } from 'rxjs/operators';
type DiscoverFilters = {
  categoryIds?: number[];
  influencerHandles?: string[];
};
@Injectable({
  providedIn: 'root'
})
export class StoreService {

  private REST_API_SERVER = '';

  path: string = '';
  pathVariantes: string = '';
  path2: string = '';

  constructor(
    private authHeaderService: AuthHeaderService,
    private httpClient: HttpClient,
    private sanctum: SanctumService
  ) {
    const id_loja = this.getIdLoja();
    this.REST_API_SERVER = `${environment.apiBaseUrl}/api/admin/store/${id_loja}/promotions`;
    this.path = `${environment.apiBaseUrl}/api/admin/store/${id_loja}/promotions`;
    this.pathVariantes = 'admin/variantes';
    this.path2 = `admin/store/${id_loja}/promotions`;

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
  }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getAccessToken()}`
    }),
  };

  async detailStoreInfoByStoreIdX(storeId: number): Promise<Observable<IStoreData>> {
    //await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}`;

    return this.httpClient.get<IStoreData>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao buscar detalhes da loja por ID:', error);
        return throwError(() => error);
      })
    );
  }


  async detailStoreInfos(store_name: string | undefined, slick?: string, widget?: string): Promise<Observable<IStoreData>> {
    console.log('chamou 3');

    await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();
    const referer = window.parent !== window ? document.referrer : window.location.origin;

    httpOptions.headers = httpOptions.headers.set('X-Full-Referer', referer);

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store`;

    const requestBody = {
      store_id: null,
      domain: null,
      subdomain: `${store_name}.slicksell.com.br`
    };

    return this.httpClient.post<IStoreData>(url, requestBody, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao buscar informações da loja pelo nome:', error);
        return throwError(() => error);
      })
    );
  }


  detailStoreInfosPublicById(store_id: string | undefined, slick?: string, widget?: string): Observable<IStoreData> {
    console.log('chamou 3')
    const parentUrl = window.parent !== window ? document.referrer : window.location.origin;

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Full-Referer': window.parent !== window ? document.referrer : window.location.origin // window.Shopify.shop
      }),
    };

    const requestBody = {
      store_id: store_id,
      domain: null,
      subdomain: null
    };

    const url = `${environment.apiBaseUrl}/api/public/admin/store_public`;

    return this.httpClient.post<IStoreData>(url, requestBody, this.httpOptions);
  }



  detailStoreInfosPublic(store_name: string | undefined, slick?: string, widget?: string): Observable<IStoreData> {
    console.log('chamou 3')
    const parentUrl = window.parent !== window ? document.referrer : window.location.origin;

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Full-Referer': window.parent !== window ? document.referrer : window.location.origin // window.Shopify.shop
      }),
    };

    const requestBody = {
      store_id: null,
      domain: null,
      subdomain: `${store_name}.slicksell.com.br`
    };

    const url = `${environment.apiBaseUrl}/api/public/admin/store_public`;

    return this.httpClient.post<IStoreData>(url, requestBody, this.httpOptions);
  }

  async detailStoreInfosByID(store_id: number | undefined): Promise<Observable<IStoreData>> {
    const httpOptions = await this.authHeaderService.getPublicHttpOptions();

    // ✅ tenta resolver store_id pelo localStorage (store_data -> store)
    let resolvedStoreId: number | undefined = store_id;

    try {
      const rawStoreData = localStorage.getItem('store_data') || localStorage.getItem('store');
      if (rawStoreData) {
        const parsed = JSON.parse(rawStoreData);

        const lsId = Number(parsed?.store_id);
        if (!Number.isNaN(lsId) && lsId > 0) {
          resolvedStoreId = lsId;
        }
      }
    } catch {
      // se der erro de JSON, ignora e usa o parâmetro
    }

    if (!resolvedStoreId) {
      // mantém comportamento atual (vai chamar com undefined e cair no catchError)
      resolvedStoreId = store_id;
    }

    console.log('detailStoreInfosByID', { store_id_param: store_id, store_id_resolved: resolvedStoreId });

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/store/${resolvedStoreId}/list_store`;

    return this.httpClient.get<IStoreData>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao buscar informações da loja:', error);
        return throwError(() => error);
      })
    );
  }





  async listarAssetsWidget(widget_id: number | undefined, page: number = 1, limit: number | null = 10): Promise<Observable<IStoreData>> {
    //await this.sanctum.initSanctum();

    const httpOptions = await this.authHeaderService.getHttpOptions();

    // Adiciona o header 'X-Full-Referer' manualmente
    httpOptions.headers = httpOptions.headers.set('X-Full-Referer', window.location.href);

    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 163;
    if (limit == null) limit = 10;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${storeId}/videoshopping/widget/${widget_id}/assets?page=${page}`;

    return this.httpClient.get<IStoreData>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao listar assets do widget:', error);
        return throwError(() => error);
      })
    );
  }





  async listarAssetsWidget2(
    widget_id: number | undefined,
    page: number = 1,
    limit: number | null = 5,
    filters?: DiscoverFilters
  ): Promise<Observable<IStoreData>> {
    console.log('listarAssetsWidget2');

    const httpOptions = await this.authHeaderService.getHttpOptions();
    httpOptions.headers = httpOptions.headers.set('X-Full-Referer', window.location.href);

    const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 163;
    const resolvedLimit = limit ?? 9;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    // ✅ monta querystring com URLSearchParams
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(resolvedLimit));

    const categoryIds = (filters?.categoryIds || []).filter(n => Number.isFinite(n));
    if (categoryIds.length) {
      params.set('category_ids', categoryIds.join(','));
    }

    const influencers = (filters?.influencerHandles || []).map(s => String(s || '').trim()).filter(Boolean);
    if (influencers.length) {
      params.set('influencers', influencers.join(','));
    }

    const url = `${baseUrl}/admin/store/${storeId}/videoshopping/widget/${widget_id}/assets?${params.toString()}`;

    return this.httpClient.get<IStoreData>(url, httpOptions).pipe(
      catchError(error => {
        console.error('Erro ao listar assets do widget 2:', error);
        return throwError(() => error);
      })
    );
  }
  // async listarAssetsWidget2(widget_id: number | undefined, page: number = 1, limit: number | null = 10): Promise<Observable<IStoreData>> {
  //   //await this.sanctum.initSanctum();
  //   console.log('listarAssetsWidget2')
  //   const httpOptions = await this.authHeaderService.getHttpOptions();
  //   httpOptions.headers = httpOptions.headers.set('X-Full-Referer', window.location.href);

  //   const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 163;
  //   if (limit == null) limit = 9;

  //   const baseUrl = environment.production
  //     ? 'https://api.slicksell.com.br/api'
  //     : 'https://stage-api.slicksell.com.br/api';

  //   const url = `${baseUrl}/admin/store/${storeId}/videoshopping/widget/${widget_id}/assets?page=${page}&limit=${limit}`;

  //   return this.httpClient.get<IStoreData>(url, httpOptions).pipe(
  //     catchError(error => {
  //       console.error('Erro ao listar assets do widget 2:', error);
  //       return throwError(() => error);
  //     })
  //   );
  // }

  listarAssetsWidgetPublic(
    widget_id: number | undefined,
    page: number = 1,
    limit: number | null = 10,
    store_id: number | undefined,
    filters?: DiscoverFilters
  ): Observable<IStoreData> {


    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
        'X-Full-Referer': window.location.href,
        'X-Mobile-App': 'true'
      }),
    };

    let id_loja = store_id ?? 163;

    const storeJson = localStorage.getItem('store');
    if (storeJson) {
      try {
        const storeObj = JSON.parse(storeJson);
        if (storeObj.SelectedStoreId) {
          id_loja = storeObj.SelectedStoreId;
        }
      } catch (e: any) {
        console.warn('não foi possível parsear o store no localStorage', e);
      }
    }

    const resolvedLimit = limit ?? 9;

    // ✅ monta querystring
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(resolvedLimit));

    const categoryIds = (filters?.categoryIds || [])
      .filter(n => Number.isFinite(n));

    if (categoryIds.length) {
      params.set('category_ids', categoryIds.join(','));
    }

    const influencers = (filters?.influencerHandles || [])
      .map(s => String(s || '').trim())
      .filter(Boolean);

    if (influencers.length) {
      params.set('influencers', influencers.join(','));
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/store/${id_loja}/videoshopping/widget/${widget_id}/assets_public?${params.toString()}`;

    return this.httpClient.get<IStoreData>(url, this.httpOptions);
  }

  getIdLoja(): any {
    try {
      const idLojaString = localStorage.getItem('ss_SelectedStoreId');
      if (idLojaString) {
        return JSON.parse(idLojaString);
      }
      return null;
    } catch (error) {
      console.error('Erro ao fazer parse do id_loja:', error);
      return null;
    }
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  getAccessToken(): string {
    return localStorage.getItem('access_token') || '';
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem('user') || '');
  }
}
